import { auth } from "@/config/firebase";
import { confirmPasswordReset, verifyPasswordResetCode } from "firebase/auth";
import { log } from "@/utils/logger";
import { getRoutes } from "@/utils/helpers";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/context/user";

const useResetPassword = () => {
    const setLoading = useUser(state => state.setGlobalLoading);
    const routes = getRoutes();
    const navigate = useNavigate();

    const onResetPassword = async (newPassword: string, oobCode: string | null) => {
        try {
            setLoading(true);
            if (!oobCode) throw new Error("Missing oobCode in parameters. $sentry-ignore");

            const email = await verifyPasswordResetCode(auth, oobCode);
            await confirmPasswordReset(auth, oobCode, newPassword);

            log.success(`Password has been successfully reset for ${email}.`);
            navigate(routes.signIn);
        } catch (e) {
            log.error(e, "onResetPassword");
        } finally {
            setLoading(false);
        }
    };

    return onResetPassword;
};

export { useResetPassword };
